import UserDetailView from './UserDetailView';

const views = {
  UserDetailView,
};
export default views;
